import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EContactChannels, IContactDetails } from '../models/IContactDetails';
import { ConfigReaderService } from '../services/util/config.reader.service';
import { SimpleContactModalComponent } from '../simple-contact-modal/simple-contact-modal.component'

@Component( {
    selector: 'app-service-button',
    templateUrl: './service-button.component.html',
    styleUrls: [ './service-button.component.scss' ]
} )
export class ServiceButtonComponent implements OnInit, AfterViewInit {

    private contactDetails: IContactDetails = undefined;
    constructor( public dialog: MatDialog,
        private readonly myConfigReaderService: ConfigReaderService,
    ) { }

    public serviceButtons: HTMLElement;
    public firstScroll: boolean = true;
    public enableContactButton: boolean = false;

    public ngOnInit(): void {
        this.myConfigReaderService.getContactDetails().subscribe(data => {
            this.contactDetails = new IContactDetails(data);
            this.enableContactButton = this.contactDetails.enableContactButton();
        });
    }

    public ngAfterViewInit(): void {
        this.serviceButtons = document.querySelector('.service-button-container');
    }

    public openSimpleContactModal(): void {
        const channel: EContactChannels = this.contactDetails.channelToUse();
        if (EContactChannels.EMAIL === channel){
            this.dialog.open( SimpleContactModalComponent, {
                panelClass: 'customDialog',
                data: {
                    contactDetails: this.contactDetails
                }        
            } );
        }else if (EContactChannels.CHAT === channel){
            window.open(this.contactDetails.tawkTo);
        }
    }

    public backTop(): void {
        const element = document.querySelector( "#header" );

        if ( element )
        {
            element.scrollIntoView( { behavior: 'smooth', block: 'start' } );
        }
    }

    public onScroll(event: any): void {
        const scrolledValue = event.target.scrollingElement.scrollTop;

        if (this.firstScroll) {
            const serviceButtons = document.querySelector('.service-button-container') as HTMLElement;
            if(serviceButtons) {
                this.serviceButtons = serviceButtons;
                this.firstScroll = false;
            }
        }

        if (scrolledValue > 150) {
            this.serviceButtons.classList.add('show');
        } else {
            this.serviceButtons.classList.remove('show');
        }
    }
}
